import { render, staticRenderFns } from "./sound_edit.vue?vue&type=template&id=e0028be6&scoped=true&"
import script from "./sound_edit.vue?vue&type=script&lang=js&"
export * from "./sound_edit.vue?vue&type=script&lang=js&"
import style0 from "./sound_edit.vue?vue&type=style&index=0&id=e0028be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0028be6",
  null
  
)

export default component.exports